import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from 'react';
import config from './config';

const host = config.backendUrl;

function App() {

  /* navbar */ 
  return (
    <div className="App">
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-left">
            <h1 className="navbar-title">Grievers + Friends</h1>
          </div>
          <div className="navbar-right">
            <ul className="navbar-items">
              <li className="navbar-item">
                <a href="#" className="navbar-link">Home</a>
              </li>
              <li className="navbar-item">
                <a href="#" className="navbar-link">About</a>
              </li>
              <li className="navbar-item">
                <a href="#" className="navbar-link">Services</a>
              </li>
              <li className="navbar-item">
                <a href="/cart" className="navbar-link">Cart</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="products">
        <div className="product">
          <h2 className="product-title">Look to the Sky</h2>
          <p className="product-description">This is a product description</p>         
          <a className="product-button" href={"/products/look-to-the-sky/"}>Personalize</a>
        </div>
      </div>
    </div>
  );
}

export default App;
